import React, { useContext } from "react";
import HealingOutlinedIcon from "@mui/icons-material/HealingOutlined";

import { ConfiguracionContext } from "../../../../context/ConfiguracionContext";
import MaestroArchivo from "../../common/MaestroArchivo";

export default function Tratamientos() {
  const {
    tratamientos,
    obtenerTratamientos,
    agregarTratamiento,
    actualizarTratamiento,
  } = useContext(ConfiguracionContext);

  return (
    <MaestroArchivo
      titulo="Tratamientos"
      entidad="tratamiento"
      layout="Tratamientos"
      icono={<HealingOutlinedIcon />}
      items={tratamientos}
      onObtener={() => obtenerTratamientos({ todos: true })}
      onAgregar={(data) => agregarTratamiento({ tratamiento: data })}
      onActualizar={(data) => actualizarTratamiento({ tratamiento: data })}
    />
  );
}
